import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useContatosSection } from "./use-contatos-section";
import { ContatosSectionView } from "./view-contatos-section";

export function ContatosSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useContatosSection(props);

  return <ContatosSectionView {...vm} />;
}

export type * from "./types-contatos-section";
